import { SortableList } from "@circle-react/components/shared/uikit/SortableList";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

import { AddLinkButton } from "./AddLinkButton";
import { LinkItem } from "./LinkItem";
import { LinkItemDragOverlay } from "./LinkItemDragOverlay";

export interface SortableLinksListProps {
  links: any[];
  onSort: (reorderedItems: any[]) => void;
}

export const SortableLinksList = ({
  links,
  onSort,
}: SortableLinksListProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isLgScreen = useLgScreenMediaQuery();
  const shouldDisable = !isAdmin || !isLgScreen;

  return (
    <SortableList
      items={links}
      onSort={onSort}
      distance={5}
      lockedVerticalAxis
      shouldUseKeyboardSensor={false}
    >
      <SortableList.List gap={0} className="flex flex-col gap-y-1">
        {links.map(link => (
          <SortableList.Item
            tabIndex={-1}
            item={link}
            disabled={shouldDisable}
            key={link.id}
          >
            <LinkItem link={link} isAdmin={isAdmin} />
          </SortableList.Item>
        ))}
        {isAdmin && <AddLinkButton />}
      </SortableList.List>
      <SortableList.DragOverlay adjustScale={false}>
        <LinkItemDragOverlay />
      </SortableList.DragOverlay>
    </SortableList>
  );
};
